import { ReactNode } from 'react';
import { GoToStepProps, StepNumber } from 'types/stepper/stepper.type';
import styles from './horizontal-stepper.module.scss';
import {
  StepperSidebar,
  SIDEBAR_TYPE,
  SIDEBAR_COLOR,
  Category,
  Typography
} from '@sanlam-glacier/app-common/components';
import { mapStepperStateToCX } from 'modules/new-business/utils/proposal-stepper/stepper-state-mapper';
import { StepConfig, StepperCategoryState } from 'types/stepper/proposal-stepper-type';

interface HorizontalStepperProps {
  stepConfig: StepConfig[];
  currentStep: number;
  isLoading?: boolean;
  goToStep?: (props: GoToStepProps) => void;
  getStepIcon?: (step: StepConfig) => ReactNode;
  isStepDisabled?: (step: StepNumber) => boolean;
}

export const HorizontalStepper = ({
  stepConfig,
  currentStep,
  isLoading,
  goToStep,
  getStepIcon = defaultStepIconFn,
  isStepDisabled = defaultIsStepDisabledFn
}: HorizontalStepperProps) => {
  const lastStep = stepConfig[stepConfig.length - 1]!;

  const getStepState = (step: StepConfig): StepperCategoryState => {
    const isCurrentStep = step.step === currentStep;
    if (isCurrentStep && step.state === StepperCategoryState.DEFAULT)
      return StepperCategoryState.SELECTED;
    return step.state;
  };

  return (
    <div className={styles.stepperRow}>
      <StepperSidebar
        sidebarType={SIDEBAR_TYPE.HORIZONTAL}
        className={styles.cxStepperOverride}
        currentRoute={`step-${currentStep}`}
        key={`step-${currentStep}`}
        sidebarColor={SIDEBAR_COLOR.LIGHT}
      >
        {stepConfig.map((step) => (
          <Category
            key={`step-${step.step}`}
            route={`step-${step.step}`}
            label={step.title}
            state={mapStepperStateToCX(getStepState(step))}
            lastCategory={step.step === lastStep.step}
            icon={getStepIcon(step)}
            onCategoryClick={() => goToStep && goToStep({ step: step.step })}
            sidebarType={SIDEBAR_TYPE.HORIZONTAL}
            disabled={isLoading || isStepDisabled(step.step) || step.customIsDisabled}
          />
        ))}
      </StepperSidebar>
    </div>
  );
};

const defaultStepIconFn = (step: StepConfig) => (
  <Typography color={Typography.COLOR.INHERIT} weight={Typography.WEIGHT.MEDIUM}>
    {step.step}
  </Typography>
);

const defaultIsStepDisabledFn = () => false;
